import { Stack, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import { IComment } from "../../../../../types/comment";
import { handleExport } from "../utils/handleCommentExport";
import { useState } from "react";
import { AddContactModal } from "./AddContactModal";
import PropTypes from "prop-types";

interface CommentsTableActionProps {
  comment: IComment;
}

export const CommentsTableActions: React.FC<CommentsTableActionProps> = ({
  comment,
}) => {
  const [addContactModalOpen, setAddContactModalOpen] =
    useState<boolean>(false);

  return (
    <>
      {addContactModalOpen && (
        <AddContactModal
          comment={comment}
          setAddContactModalOpen={setAddContactModalOpen}
        />
      )}
      <Stack direction={"row"} spacing={2} sx={{ mt: 2 }}>
        <Button
          sx={{ mb: 1 }}
          variant="outlined"
          onClick={() => handleExport("csv", comment)}
        >
          <DownloadIcon sx={{ mr: 1 }} /> CSV
        </Button>

        <Button
          sx={{ mb: 1 }}
          variant="outlined"
          onClick={() => setAddContactModalOpen(true)}
        >
          <AddIcon sx={{ mr: 1 }} /> Contact
        </Button>
      </Stack>
    </>
  );
};

CommentsTableActions.propTypes = {
  comment: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    author: PropTypes.string,
    authorEmail: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
};
